/*eslint-disable*/
import config from "../modules/siteConfig";
import axios from "axios";

function buildForms() {
    let forms = document.querySelectorAll(".customForm");

    if (forms.length > 0) {
        const d3 =  Object.assign({}, require("d3-selection"), require("d3-array"), require("d3-dsv"));
        let defaultPlaceholder = "N/A";
        
        forms.forEach(form => {
            let mailTo = form.getAttribute("data-mailTo");
            /* let emailTemplateId = form.getAttribute("data-emailTemplateId"); */
            let subjectLine = form.getAttribute("data-subjectLine");
            let formTitle = form.getAttribute("data-formTitle");
            let redirectPath = form.getAttribute("data-redirectPath");
            let jsonString = form.getAttribute("data-json");
            let jsonReplace = jsonString.replace(/'/g, '"');
            let jsonFields = JSON.parse(jsonReplace);
            let csv = jsonFields.data.replace(/<br\/>/g, "\n");
            let data = d3.csvParse(csv);

            let formEl = d3.select(form).select("form");
            let formNode = formEl.node();
            let formBody = formEl.select(".customForm__body");

            /* split form data into sections */
            let prev = 0;
            let sectionedData = [];
            data.forEach((d,i) => {
                if (d.sectionLabel || !d.fieldValue) {
                    sectionedData.push(data.slice(prev, i));
                    prev = i;
                }
            });
            sectionedData.push(data.slice(prev)); /* include remainder or entirety, if no labels specified */

            /* iterate through sections */
            sectionedData.forEach(dataGroup => {
                let section = formBody.append("div")
                    .classed("customForm__section", true)
                
                let sectionLabel = (dataGroup[0].sectionLabel || !dataGroup[0].fieldValue) ? dataGroup.shift().sectionLabel : null;

                if (sectionLabel) {
                    section.append("div")
                        .classed("customForm__sectionTitle", true)
                        .text(sectionLabel);
                }

                let customFields = section.selectAll(".customForm__field")
                        .data(dataGroup)
                    .join("div")
                        .attr("class", d => `customForm__field customForm__field--${d.fieldType.toLowerCase()}`);

                customFields.append("label")
                    .attr("for", d => d.fieldValue)
                    .text(d => d.fieldLabel + (d.isRequired.toLowerCase() == "true" ? '*' : ''));

                /* append inputs */
                customFields.filter(d => ["Text", "Checkbox", "Email", "Tel"].includes(d.fieldType))
                    .append("input")
                        .attr("class", "customForm__input")
                        .attr("type", d => d.fieldType.toLowerCase())
                        .attr("name", d => d.fieldValue)
                        .attr("placeholder", d => d.placeholderText.toLowerCase() == "false" ? null : d.placeholderText || defaultPlaceholder)
                        .each(function(d) {
                            if (d.isRequired.toLowerCase() == "true") d3.select(this).attr("required", true);
                        });

                /* append dropdowns */
                customFields.filter(d => d.fieldType.toLowerCase() == "dropdown") /* || "select" */
                    .append("select")
                        .attr("class", "customForm__select")
                        .attr("name", d => d.fieldValue)
                        .attr("placeholder", d => d.placeholderText.toLowerCase() == "false" ? null : d.placeholderText || defaultPlaceholder)
                        .each(function (d) {
                            let el = d3.select(this);
                            if (d.isRequired.toLowerCase() == "true") el.attr("required", true);

                            /* append options */
                            el.selectAll("option")
                                    .data(getSelectOptions(data,d))
                                .join("option")
                                    .attr("value", d => d[0])
                                    .text(d => d[1]);
                            
                            el.append("option")
                                .attr("value", "none")
                                .attr("selected", true)
                                .text(d => d.placeholderText.toLowerCase() == "false" ? null : d.placeholderText || defaultPlaceholder);
                        });
            });

            addUtmData(formBody);

            /* listen for form submit */
            formNode.addEventListener("submit", function(e) {
                form.classList.add("customForm--submitted", true);

                let spinner = form.getElementsByClassName("customForm__spinner")[0];
                showSpinner(spinner);

                let optionalSubjectEntry = subjectLine ? { subjectLine: subjectLine } : {};
                let optionalFormTitleEntry = formTitle ? { formTitle: formTitle } : {};

                let params = Object.assign({
                        mailTo: mailTo
                    },
                    optionalSubjectEntry,
                    optionalFormTitleEntry,
                    extractFields(formNode)
                );

                postData(params).then(response => {
                    formNode.submit();
                    hideSpinner(spinner, 250);
                    const path = location.pathname;
                    const formHandlerId = formNode.getAttribute("action") || path;
                    const pageName = document.querySelector("title").textContent;

                    const data = {
                        event: "form-handler-submission",
                        formId: formHandlerId,
                        page: {
                            category: "Form Event",
                            label: `${pageName} | ${path}`
                        }
                    };
                    window.dataLayer.push(data);
                    window.location.href = redirectPath;
                });
            });
        });
    }
}

function getSelectOptions(data,d) {
    let rowNumber = d.rowNumber;                        
    let assoc = [];

    data.forEach(d => {
        if (d[`dropdown${rowNumber}__value`] || d[`dropdown${rowNumber}__text`]) {
            assoc.push([d[`dropdown${rowNumber}__value`] || "", d[`dropdown${rowNumber}__text`] || ""]);
        };
    });

    return assoc;
}

function postData(params = {}) {
    return axios({
        method: "post",
        url: `${config.context || ""}/.rest/api/custom-form/submit`,
        data: params
    });
}

function showSpinner(spinner) {
    if (spinner) {
        spinner.classList.remove("hidden");
        spinner.classList.add("spinning");
    }
}

function hideSpinner(spinner, i = 500) {
    if (spinner) {
        spinner.classList.remove("spinning");
        window.setTimeout(function() {
            spinner.classList.add("hidden");
        }, i);
    }
}

function extractFields(form) {
    var fields = {};
	for (var i = 0; i < form.elements.length; i++) {

		var field = form.elements[i];

        // Ignore fields without a name, submits, buttons, file and reset inputs, and disabled fields
		if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;

		// If a multi-select, get all selections
		/* if (field.type === 'select-multiple') {
            fields[field.name] = [];                
			for (var n = 0; n < field.options.length; n++) {
				if (!field.options[n].selected) continue;
                fields[field.name].push(field.options[n].value));
			}
		} elseif... */

        if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
            fields[field.name] = field.value;
        }
	}
    return fields;
}

function addUtmData(formBody) {
    let utmFields = ["utm_audience","utm_author","utm_campaign","utm_content","utm_medium","utm_source","utm_type"].map(fieldName => {
        return {
            name: fieldName,
            value: getParameterByName(fieldName)
        };
    });

    /* append and set all hidden UTM fields */
    let utmGroup = formBody.append("div")
            .classed("customForm__utmGroup", true)
    
    utmGroup.selectAll("input")
            .data(utmFields)
        .enter().append("input")
            .attr("type", "hidden")
            .attr("name", d => d.name)
            .attr("value", d => d.value)

    // Parse the URL: adapted from https://jennamolby.com
    function getParameterByName(name) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
        var results = regex.exec(location.search);
        return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }
}

const init = () => {
    buildForms();
};

export default { init };